"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroAssetIcon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _react = _interopRequireWildcard(require("react"));
var _generated = require("../../../generated");
var _Icon = require("../../icon/Icon");
var _DashboardsIcon = _interopRequireDefault(require("./DashboardsIcon20"));
var _ReportsIcon = _interopRequireDefault(require("./ReportsIcon20"));
// Map each variant to the icon and bg color it should represent for easy lookup
const variantMap = {
  dashboard: {
    icon:
    /*#__PURE__*/
    // @TODO - this icon should be migrated to the DashboardsIcon when addeed in V5
    _react.default.createElement(_Icon.Icon, {
      size: 20,
      color: (0, _designTokensReact.color)("color--background--spectrum-green--stronger", _designTokens.ursaColors.green600)
    }, /*#__PURE__*/_react.default.createElement(_DashboardsIcon.default, null)),
    background: (0, _designTokensReact.color)("color--background--spectrum-green--weakest", _designTokens.ursaColors.green75)
  },
  report: {
    icon:
    /*#__PURE__*/
    // @TODO - this icon should be migrated to the ReportsIcon when added in V5
    _react.default.createElement(_Icon.Icon, {
      size: 20,
      color: (0, _designTokensReact.color)("color--background--spectrum-orange--strong", _designTokens.ursaColors.orange500)
    }, /*#__PURE__*/_react.default.createElement(_ReportsIcon.default, null)),
    background: (0, _designTokensReact.color)("color--background--spectrum-orange--weakest", _designTokens.ursaColors.orange75)
  },
  sheet: {
    icon: /*#__PURE__*/_react.default.createElement(_generated.SheetIcon, {
      size: 20,
      color: (0, _designTokensReact.color)("color--background--spectrum-violet--strongest", _designTokens.ursaColors.violet700)
    }),
    background: (0, _designTokensReact.color)("color--background--spectrum-violet--weakest", _designTokens.ursaColors.violet50)
  },
  form: {
    icon: /*#__PURE__*/_react.default.createElement(_generated.FormsIcon, {
      size: 20,
      color: (0, _designTokensReact.color)("color--background--spectrum-orchid--stronger", _designTokens.ursaColors.orchid600)
    }),
    background: (0, _designTokensReact.color)("color--background--spectrum-orchid--weakest", _designTokens.ursaColors.orchid50)
  },
  workapp: {
    icon: /*#__PURE__*/_react.default.createElement(_generated.WorkAppIcon, {
      size: 20,
      color: (0, _designTokensReact.color)("color--background--spectrum-blue--strongest", _designTokens.ursaColors.blue700)
    }),
    background: (0, _designTokensReact.color)("color--background--spectrum-blue--weakest", _designTokens.ursaColors.blue50)
  },
  workspace: {
    icon: /*#__PURE__*/_react.default.createElement(_generated.WorkspacesIcon, {
      size: 20,
      color: (0, _designTokensReact.color)("color--background--spectrum-azure--stronger", _designTokens.ursaColors.azure600)
    }),
    background: (0, _designTokensReact.color)("color--background--spectrum-azure--weakest", _designTokens.ursaColors.azure75)
  }
};
const HeroAssetIcon = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    variant,
    size,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(StyledContainer, {
    size: size,
    backgroundColor: variantMap[variant].background
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, (0, _extends2.default)({
    size: 20,
    ref: ref
  }, rest), variantMap[variant].icon));
});
exports.HeroAssetIcon = HeroAssetIcon;
HeroAssetIcon.displayName = "HeroAssetIcon";
const StyledContainer = _styled.default.span(_ref2 => {
  let {
    size,
    backgroundColor
  } = _ref2;
  return `
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${size}px;
    min-width: ${size}px;
    height: ${size}px;
    min-height: ${size}px;
    background-color: ${backgroundColor};
    border-radius: ${_designTokens.border.radius20};
`;
});
//# sourceMappingURL=HeroAssetIcon.js.map